import { axiosInstance } from '@/http-common'

/**
 * Plan a driving route through the given points (start, optional waypoints, destination)
 */
export async function postRoutePlan(points: Array<{lat: number, lng: number}>): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/route/plan', { points })
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

/**
 * Add tacho job
 */
export async function postTachoJob(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/tacho/add', data)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

/**
 * Add tacho jobs for all drivers
 */
export async function postAllDriversTachoJobs(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/tacho/add/all_drivers')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}
/**
 * Sends a POST request to mark given notification histories as read.
 *
 * @param notificationsHistory - An array of notification history IDs to be marked as read.
 * @returns Promise - Resolves with the response if successful, otherwise rejects with the error.
 */
export function postMarkAsReadNotificationsHistory(notificationsHistory: Array<any>): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/notification-history/mark-read', {
            ids: notificationsHistory
        })
            .then(response => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            });
    });
}

/**
 * Add tacho jobs for all vehicles
 */
export async function postAllVehiclesTachoJobs(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/tacho/add/all_vehicles')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

/**
 * Add tacho jobs for all expired reminders
 */
export async function postAllExpiredTachoJobs(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/tacho/add/all_expired')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function postCreateApiToken(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/api/v1/client/token/authenticate`)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}